import React from 'react';
import { createUseStyles } from 'react-jss';
import clsx from 'clsx';

enum IconSize {
    Small = 16,
    Medium = 24,
}

export interface IIconProps {
    icon: string;
    alt: string;
    size?: IconSize;
    className?: string;
}

const useStyles = createUseStyles<string, Required<Pick<IIconProps, 'size'>>>({
    root: {
        width: data => data.size,
        height: data => data.size,
    },
});

export const Icon: React.FunctionComponent<IIconProps> = props => {
    const styles = useStyles({ size: props.size ?? IconSize.Medium });
    return <img src={props.icon} alt={props.alt} className={clsx(styles.root, props.className)} />;
};
